import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { BarChart3, Hash, Target, Repeat } from "lucide-react";
import { ResultRow, animalNames, animalEmojis } from "./constants";

interface SummaryCardsProps {
  filtered: ResultRow[];
}

const SummaryCards: React.FC<SummaryCardsProps> = ({ filtered }) => {
  // Grupo mais frequente
  const grupoCount: Record<number, number> = {};
  filtered.forEach(r => {
    grupoCount[r.grupo] = (grupoCount[r.grupo] || 0) + 1;
  });
  const topGrupo = Object.entries(grupoCount)
    .sort((a, b) => b[1] - a[1])[0];

  // Dezena mais frequente
  const dezenaCount: Record<string, number> = {};
  filtered.forEach(r => {
    const dez = r.milhar.slice(-2);
    dezenaCount[dez] = (dezenaCount[dez] || 0) + 1;
  });
  const topDezena = Object.entries(dezenaCount)
    .sort((a, b) => b[1] - a[1])[0];

  // Milhar que mais repetiu
  const milharCount: Record<string, number> = {};
  filtered.forEach(r => {
    milharCount[r.milhar] = (milharCount[r.milhar] || 0) + 1;
  });
  const topMilhar = Object.entries(milharCount)
    .filter(([_, c]) => c > 1)
    .sort((a, b) => b[1] - a[1])[0];

  const grupoNum = topGrupo ? parseInt(topGrupo[0]) : 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3">
      <Card>
        <CardContent className="p-3 sm:p-4 flex items-center gap-2 sm:gap-3">
          <div className="p-1.5 sm:p-2 rounded-lg bg-primary/10">
            <BarChart3 className="h-4 w-4 sm:h-5 sm:w-5 text-primary" />
          </div>
          <div>
            <p className="text-[10px] sm:text-xs text-muted-foreground">Sorteios</p>
            <p className="text-lg sm:text-xl font-bold">{filtered.length}</p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-3 sm:p-4 flex items-center gap-2 sm:gap-3">
          <div className="text-xl sm:text-2xl">{animalEmojis[grupoNum] || '🎯'}</div>
          <div className="min-w-0">
            <p className="text-[10px] sm:text-xs text-muted-foreground">Grupo Quente</p>
            <p className="text-xs sm:text-sm font-bold truncate">
              {topGrupo ? `G${String(grupoNum).padStart(2, '0')} ${animalNames[grupoNum]}` : '-'}
            </p>
            {topGrupo && <p className="text-[10px] sm:text-xs text-muted-foreground">{topGrupo[1]}x</p>}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-3 sm:p-4 flex items-center gap-2 sm:gap-3">
          <div className="p-1.5 sm:p-2 rounded-lg bg-primary/10">
            <Hash className="h-4 w-4 sm:h-5 sm:w-5 text-primary" />
          </div>
          <div>
            <p className="text-[10px] sm:text-xs text-muted-foreground">Top Dezena</p>
            <p className="text-lg sm:text-xl font-bold font-mono">{topDezena ? topDezena[0] : '-'}</p>
            {topDezena && <p className="text-[10px] sm:text-xs text-muted-foreground">{topDezena[1]}x</p>}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-3 sm:p-4 flex items-center gap-2 sm:gap-3">
          <div className="p-1.5 sm:p-2 rounded-lg bg-primary/10">
            <Repeat className="h-4 w-4 sm:h-5 sm:w-5 text-primary" />
          </div>
          <div>
            <p className="text-[10px] sm:text-xs text-muted-foreground">Milhar Repetido</p>
            <p className="text-lg sm:text-xl font-bold font-mono">{topMilhar ? topMilhar[0] : '-'}</p>
            {topMilhar && <p className="text-[10px] sm:text-xs text-muted-foreground">{topMilhar[1]}x</p>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SummaryCards;
